<template>
    <div
        class="tintable-image"
        :style="maskStyle"
        @click="$emit('click')" />
</template>

<script>
export default {
    props: {
        url: { type: String, default: '' }
    },
    computed: {
        maskStyle () {
            return this.url ? this.getMask() : ''
        }
    },
    methods: {
        getMask () {
            return (
                '-webkit-mask-box-image: url(' +
        this.url +
        ');mask: url(' +
        this.url +
        ');'
            )
        }
    }
}
</script>
